<template>
  <div id="approveSet">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>审批设置</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="approveSetActive" @tab-click="handleClick">
        <!-- 项目审批 -->
        <el-tab-pane label="项目审批" name="1">
          <div id="projectFile">
            <div class="fileBox">
              <!-- 表格行 -->
              <div class="tableBox">
                <tree-table
                  :is-fold="false"
                  :data="tableData1"
                  children-prop="child"
                  :columns="columns"
                  :show-row-hover="false"
                  :expand-type="false"
                  :selection-type="false"
                >
                  <template slot="name" slot-scope="scope">
                    <!-- <span v-if="scope.row.name">{{scope.row.name +'123'}}</span> -->
                  </template>
                  <template slot="upPeople" slot-scope="scope">
                    <!-- v-if="scope.row.is_charge=='1' && scope.row.approve.length>0" -->
                    <span
                      v-if="scope.row.is_charge=='1'"
                      class="overFlowInTable"
                      :title="scope.row.approve_str"
                    >{{scope.row.approve_str}}</span>
                    <!-- <span v-if="scope.row.approve">123</span> -->
                  </template>
                  <template slot="sendPeople" slot-scope="scope">
                    <span
                      v-if="scope.row.is_charge=='1'"
                      class="overFlowInTable"
                      :title="scope.row.cc_str"
                    >
                      <span>{{scope.row.cc_str}}</span>
                    </span>
                  </template>
                  <template slot="edit" slot-scope="scope">
                    <el-button
                      class="checkBtn"
                      @click="editPeople(scope.row)"
                      :disabled="isAdmin1 == 0 ? false : true"
                      v-if="scope.row.is_charge=='1'"
                    >编辑</el-button>
                  </template>
                </tree-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 财务审批 -->
        <el-tab-pane label="财务审批" name="2">
          <div id="projectFile">
            <div class="fileBox">
              <!-- 表格行 -->
              <div class="tableBox">
                <el-table
                  :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
                  :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
                  :data="tableData2"
                  stripe
                  height="calc(100%)"
                  style="width: 100%; "
                >
                  <el-table-column
                    prop="stage_name"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="审批类型"
                  ></el-table-column>
                  <el-table-column
                    prop="address"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="审批人"
                  >
                    <template slot-scope="scope">
                      <span
                        v-for="item in scope.row.approve"
                        style="margin-right:10px"
                      >{{item.nickname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="department_name"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="抄送人"
                  >
                    <template slot-scope="scope">
                      <span v-for="item in scope.row.cc" style="margin-right:10px">{{item.nickname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" width="300" align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        :disabled="isAdmin2 == 0 ? false : true"
                        @click="handleEditProject(scope.row)"
                        class="tableBtn"
                      >编辑</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age" v-if="showForm=='1'">新增项目类型</span>
        <span class="title-age" v-if="showForm=='1-edit'">设置财务审批</span>
        <span class="title-age" v-if="showForm=='2'">新增评价类型</span>
        <span class="title-age" v-if="showForm=='2-edit'">设置项目审批</span>
      </div>
      <div class="diaContainer">
        <!-- 财务流程编辑表单 -->
        <el-form ref="form" label-width="30%" v-if="showForm=='1-edit' && isReloadForm">
          <el-form-item label="审批人" style="margin-bottom:0px">
            <my-transfer
              v-if="isReload"
              :selectedId="selectIds[0]"
              :nextIndex="'0'"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChange"
            ></my-transfer>
            <span @click="handleAdd" class="addLast">添加下一级审批</span>
          </el-form-item>
          <el-form-item
            v-if="addFormData.charge.length>1"
            v-for="(item,index) in addFormData.charge"
          >
            <my-transfer
              v-if="isReload && index!=0"
              :selectedId="selectIds[index]"
              :nextIndex="index"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChange"
            ></my-transfer>
            <i
              v-if="index!=0"
              @click="handleremove(index)"
              style="line-height:50px;margin-left:20px"
              class="el-icon-circle-close"
            ></i>
          </el-form-item>
          <el-form-item label="预设审批人" style="margin-top:20px">
            <my-transfers
              v-if="isReload"
              :selectedId="selectIdsss"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChangess"
            ></my-transfers>
          </el-form-item>
          <el-form-item label="抄送人" style="margin-top:20px">
            <my-transfers
              v-if="isReload"
              :selectedId="selectIdss"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChanges"
            ></my-transfers>
          </el-form-item>
        </el-form>
        <!-- 项目流程编辑表单 -->
        <el-form ref="form" label-width="30%" v-if="showForm=='2-edit' && isReloadForm">
          <!-- <el-form-item label="项目类型" style="margin-bottom:20px"> -->
          <el-form-item label="负责部门" style="margin-bottom:20px">
            <el-radio-group @change="selectPermitChange" v-model="addFormData.project_type">
              <el-radio
                v-for="item in projectTypeList"
                :label="item.department_id"
              >{{item.department_name}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="许可类型" style="margin-bottom:20px" v-if="is_class">
            <el-radio-group @change="selectPermitChange" v-model="addFormData.permit_type">
              <el-radio :label="'2'">许可类</el-radio>
              <el-radio :label="'1'">一般类</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="行业类型" v-if="is_class && addFormData.permit_type=='2'">
            <el-radio-group @change="selectPermitSubChange" v-model="addFormData.permit_type_sub">
              <el-radio :label="'1'">危化</el-radio>
              <el-radio :label="'2'">冶金</el-radio>
              <el-radio :label="'3'">矿山</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批人" style="margin-bottom:0px">
            <my-transfer
              v-if="isReload"
              :selectedId="selectIds[0]"
              :nextIndex="'0'"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChange"
            ></my-transfer>
            <span @click="handleAdd" class="addLast" v-if="isNextDisable">添加下一级审批</span>
          </el-form-item>
          <el-form-item
            v-if="addFormData.charge.length>1"
            v-for="(item,index) in addFormData.charge"
          >
            <my-transfer
              v-if="isReload && index!=0"
              :selectedId="selectIds[index]"
              :nextIndex="index"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChange"
            ></my-transfer>
            <i
              v-if="index!=0"
              @click="handleremove(index)"
              style="line-height:50px;margin-left:20px"
              class="el-icon-circle-close"
            ></i>
          </el-form-item>
          <el-form-item label="抄送人" style="margin-top:20px">
            <my-transfers
              v-if="isReload"
              :selectedId="selectIdss"
              :isSelected="'1'"
              style="width:65%"
              @my-transfer-change="transferChanges"
            ></my-transfers>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="addFlag" @click="DiaClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MyTransfer from '../../components/MyTransfer'
import MyTransfers from '../../components/MyTransfer'
import MyTransferss from '../../components/MyTransfer'
import MyTransfersss from '../../components/MyTransfer'
export default {
  data() {
    return {
      isNextDisable: true,
      tiemID: null,
      timeDou: 100,
      checkOutId: '',
      is_class: false,
      isAdmin1: '0',
      isAdmin2: '0',
      isReload: true,
      editControlId: '',
      selectIds: [[]],
      // 抄送人
      selectIdss: [],
      // 预设审批人
      selectIdsss: [],
      addFlag: false,
      showForm: '',
      approveSetActive: '1',
      searchInfo1: '',
      searchInfo2: '',
      searchInfo3: '',
      currentUserPage: 1,
      userPageSize: 10,

      currentPage1: 1,
      pageSize1: 10,
      total1: 0,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      currentPage3: 1,
      pageSize3: 10,
      total3: 0,

      editClassName: '',
      editClassId: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      userTotal: 0,
      dialogVisible: false,

      editUserId: '',
      tableData1: [],
      tableData2: [],
      tableData3: [],
      // 新增表单
      addFormData: {
        project_type: '',
        permit_type: '1',
        permit_type_sub: '0',
        charge: [''],
        cc: '',
        preset_str: '',
      },
      columns: [
        {
          label: '阶段名称',
          type: 'template',
          template: 'name1',
          prop: 'stage_name',
          width: '300',
        },
        {
          label: '审批人',
          type: 'template',
          template: 'upPeople',
          width: '425',
        },
        {
          label: '抄送人',
          type: 'template',
          template: 'sendPeople',
          width: '425',
        },
        {
          label: '操作',
          type: 'template',
          width: '150',
          template: 'edit',
        },
      ],
      tableData: [],
      props: {
        label: 'label',
        children: 'children',
      },
      member_id: '',
      data: [
        {
          id: 1,
          label: '邦泰1',
          children: [
            {
              id: 4,
              label: '邦泰2',
            },
          ],
        },
      ],
      token: '',
      projectTypeList: [],
      checkOutImgIndex: '',
      isReloadForm: true,
    }
  },
  methods: {
    selectPermitChange() {
      this.isReload = false
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
      this.getStagecharge()
    },
    selectPermitSubChange() {
      this.isReload = false
      this.getStagecharge()
    },
    handleremove(index) {
      console.log('index', index)
      this.isReloadForm = false
      this.addFormData.charge.splice(index, 1)
      this.selectIds.splice(index, 1)
      this.addFormData.charge.forEach((item, index) => {
        this.selectIds[index] = item.split(',')
      })
      setTimeout(() => {
        this.isReloadForm = true
      })
      console.log('123', this.addFormData.charge)
      console.log('456', this.selectIds)
    },
    handleAdd() {
      console.log('this.addFormData.charge', this.addFormData.charge)
      this.addFormData.charge.push('')
    },
    transferChange(data, index) {
      console.log('data', data)
      let index1 = parseInt(index)
      this.addFormData.charge[index1] = ''
      console.log(
        'this.addFormData.charge[index1]',
        this.addFormData.charge[index1]
      )
      data.forEach((item) => {
        this.addFormData.charge[index1] += item.id + ','
      })
      this.addFormData.charge[index1] = this.addFormData.charge[
        index1
      ].substring(0, this.addFormData.charge[index1].length - 1)
      console.log('自组建给父穿得选中的值--分析人员', data)
      console.log('asdasdasdasdas', this.addFormData.charge)
    },
    // **获取项目阶段审批人
    async getStagecharge() {
      console.log(this.is_class)
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('stage_code', this.checkOutId)
      if (this.is_class) {
        param.append('permit_type', this.addFormData.permit_type)
      }
      if (this.is_class) {
        param.append('permit_type_sub', this.addFormData.permit_type_sub)
      }
      // param.append('permit_type', this.addFormData.permit_type)
      // param.append('permit_type_sub', this.addFormData.permit_type_sub)
      param.append('project_type', this.addFormData.project_type)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/get_stage_charge',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log('点击的详情1', res.datas.list1)
      console.log('点击的详情2', res.datas.list2)

      this.isReload = true

      this.addFormData.charge = []
      this.selectIds = []
      res.datas.list1.forEach((item, index) => {
        let a = ''
        let arr = []

        item.forEach((items, indexs) => {
          a += items.member_id + ','
          arr.push(items.member_id)
        })
        console.log('arrrrrrrr', arr)
        a = a.substring(0, a.length - 1)
        this.addFormData.charge.push(a)
        this.selectIds.push(arr)
      })
      console.log('截取后后后', this.addFormData.charge)
      console.log('截取后后后ids', this.selectIds)

      // 抄送人
      this.addFormData.cc = ''
      this.selectIdss = []
      if (res.datas.list2) {
        this.selectIdss = res.datas.list2.map((item) => item.member_id)
      }

      this.selectIdss.forEach((item) => {
        this.addFormData.cc += item + ','
      })
      this.addFormData.cc = this.addFormData.cc.substring(
        0,
        this.addFormData.cc.length - 1
      )
      console.log('截取后的表单cc', this.addFormData.cc)
      // 预设审批人
      this.selectIdsss = []
      this.addFormData.preset_str = ''
      if (res.datas.list3) {
        this.selectIdsss = res.datas.list3.map((item) => item.member_id)
      }

      this.selectIdsss.forEach((item) => {
        this.addFormData.preset_str += item + ','
      })
      this.addFormData.preset_str = this.addFormData.preset_str.substring(
        0,
        this.addFormData.preset_str.length - 1
      )

      setTimeout(() => {
        this.isReload = true
      })
    },
    // *点击项目审批编辑(查看详情)
    async editPeople(row) {
      // return console.log('roew', row)
      if (row.stage_name == '项目分配') {
        this.isNextDisable = false
      } else {
        this.isNextDisable = true
      }
      if (row.is_class == '0') {
        this.is_class = false
      } else if (row.is_class == '1') {
        this.is_class = true
      }
      this.checkOutId = row.stage_code
      this.editControlId = row.stage_code
      this.getStagecharge()
      this.showForm = '2-edit'
      this.dialogVisible = true
    },
    // 预设审批人
    transferChangess(data) {
      this.addFormData.preset_str = ''
      data.forEach((item) => {
        this.addFormData.preset_str += item.id + ','
      })
      this.addFormData.preset_str = this.addFormData.preset_str.substring(
        0,
        this.addFormData.preset_str.length - 1
      )
      console.log('自组建给父穿得选中的值--分析人员3333', data)
      console.log('asdasdasdasdas333', this.addFormData.preset_str)
    },
    // 抄送人
    transferChanges(data) {
      this.addFormData.cc = ''
      data.forEach((item) => {
        this.addFormData.cc += item.id + ','
      })
      this.addFormData.cc = this.addFormData.cc.substring(
        0,
        this.addFormData.cc.length - 1
      )
      console.log('自组建给父穿得选中的值--分析人员22222', data)
      console.log('asdasdasdasdas22222', this.addFormData.cc)
    },
    DiaClick() {
      if (this.showForm === '2') {
        // 新增部门
      } else if (this.showForm === '2-edit') {
        // 编辑流程
        this.editProjectContro()
      } else if (this.showForm === '1-edit') {
        // 编辑成员
        this.editFinance()
      } else if (this.showForm === '1') {
        // 编辑成员
      }
    },
    // *编辑财务类型
    async editFinance() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)
        param.append('stage_code', this.editControlId)

        param.append('charge_json', JSON.stringify(this.addFormData.charge))
        param.append('cc_json', this.addFormData.cc)
        param.append('preset_str', this.addFormData.preset_str)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/set_finance_stage_charge',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getProjectFinanceList()
      }, this.timeDou)
    },
    // *获取财务审批流程列表
    async getProjectFinanceList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_stage',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData2 = res.datas.listInfo
      // :disabled="isAdmin1==0 ? false : true"
      this.isAdmin2 = res.datas.admin_state

      console.log('this.isAdmin1 = res.datas.admin_state', this.isAdmin1)
      console.log('财务列表', this.tableData2)
    },
    // *点击财务审批设置(查看详情)
    async handleEditProject(row) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('stage_code', row.stage_code)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/get_finance_stage_charge',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // console.log('点击的详情1', res.datas.list1)
      // console.log('点击的详情2', res.datas.list2)

      this.isReload = true
      this.editControlId = row.stage_code

      this.addFormData.charge = []
      this.selectIds = []
      res.datas.list1.forEach((item, index) => {
        let a = ''
        let arr = []

        item.forEach((items, indexs) => {
          a += items.member_id + ','
          arr.push(items.member_id)
        })
        a = a.substring(0, a.length - 1)
        this.addFormData.charge.push(a)
        this.selectIds.push(arr)
      })
      console.log('截取后后后', this.addFormData.charge)
      console.log('截取后后后ids', this.selectIds)

      // 抄送人
      this.selectIdss = []
      this.addFormData.cc = ''
      if (res.datas.list2) {
        this.selectIdss = res.datas.list2.map((item) => item.member_id)
      }

      this.selectIdss.forEach((item) => {
        this.addFormData.cc += item + ','
      })
      this.addFormData.cc = this.addFormData.cc.substring(
        0,
        this.addFormData.cc.length - 1
      )

      // 预设审批人
      this.selectIdsss = []
      this.addFormData.preset_str = ''
      if (res.datas.list3) {
        this.selectIdsss = res.datas.list3.map((item) => item.member_id)
      }

      this.selectIdsss.forEach((item) => {
        this.addFormData.preset_str += item + ','
      })
      this.addFormData.preset_str = this.addFormData.preset_str.substring(
        0,
        this.addFormData.preset_str.length - 1
      )

      this.showForm = '1-edit'
      this.dialogVisible = true
    },

    // *编辑项目审批提交
    async editProjectContro() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('stage_code', this.editControlId)

        param.append('charge', JSON.stringify(this.addFormData.charge))
        param.append('cc', this.addFormData.cc)
        param.append('project_type', this.addFormData.project_type)
        if (this.is_class) {
          param.append('permit_type', this.addFormData.permit_type)
        }
        if (this.is_class) {
          param.append('permit_type_sub', this.addFormData.permit_type_sub)
        }
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/set_stage_charge',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getProjectControlList()
      }, this.timeDou)
    },
    // *获取项目流程列表
    async getProjectControlList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/system_stage',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData1 = res.datas.listInfo
      // :disabled="isAdmin1==0 ? false : true"
      this.isAdmin1 = res.datas.admin_state

      // return this.tableData1.forEach((item) => {
      //   if (item.children) {
      //     item.children.forEach((items) => {
      //       if (items.children) {
      //         items.children.forEach((itemss) => {
      //           itemss.approve_show = ''
      //           let str3 = ''
      //           itemss.approve.forEach((a1) => {
      //             str1 += a1 + ' '
      //           })
      //           itemss['approve_show'] = str3
      //         })
      //       } else {
      //         let str2 = ''
      //         items.approve.forEach((a1) => {
      //           str1 += a1 + ' '
      //         })
      //         items['approve_show'] = str2
      //       }
      //     })
      //   } else {
      //     let str1 = ''
      //     item.approve.forEach((a1) => {
      //       str1 += a1 + ' '
      //     })
      //     item['approve_show'] = str1
      //   }
      // })
      console.log('this.isAdmin1 = res.datas.admin_state', this.isAdmin1)
      console.log('项目流程列表', this.tableData1)
    },
    // *获取项目类型(改为获取部门列表)
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        // url: '/api/Project/project_type',
        url: '/api/Project/is_business_department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      if (this.projectTypeList.length > 0)
        // this.addFormData.project_type = this.projectTypeList[0].project_type_id
        this.addFormData.project_type = this.projectTypeList[0].department_id
      console.log('项目类型列表1111111', this.projectTypeList)
    },
    handleClick(tab, event) {
      console.log(tab, event)

      if (tab.index == '0') {
        this.getProjectControlList()
      } else if (tab.index == '1') {
        this.getProjectFinanceList()
      }
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.addFormData = {
        project_type: '',
        permit_type: '1',
        permit_type_sub: '0',
        charge: [''],
        cc: '',
        preset_str: '',
      }
      if (this.showForm == '2-edit') {
        console.log('this.projectTypeList', this.projectTypeList)
        if (this.projectTypeList.length > 0) {
          this.addFormData.project_type = this.projectTypeList[0].department_id
        }
      }
      this.checkOutId = ''
      this.is_class = false
      this.selectIds = [[]]
      this.selectIdss = []
      this.selectIdsss = []
      this.isReload = false

      this.editClassId = ''
      this.editUserId = ''
      this.addFlag = false
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
    this.getProjectTypeList()
    this.getProjectControlList()
  },
  components: {
    MyTransfer,
    MyTransfers,
  },
}
</script>
<style lang="less" scoped>
#approveSet {
  /deep/ .filter-dash-btn {
    height: 50px;
  }
  /deep/.filter-tips-default {
    height: 50px;
  }
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      /deep/.el-button {
        font-size: 20px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 48px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    /deep/.tableSearch {
      width: 28%;
      // (deep)
      .el-input__inner {
        height: 48px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
      }
    }

    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-cascader {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: inherit;
      }
    }
    .el-input__inner {
      font-size: 18px;
      width: 80%;
      height: 56px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        font-size: 18px;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      // height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .el-radio {
        margin-top: 10px;
        display: flex;
        align-items: center;
        // margin-right: 15%;
        margin-right: 20px;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
}

#projectFile {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  /deep/.checkBtn {
    color: #0099ff;
    border-color: #0099ff;
    font-weight: normal;
    padding: 0 22px;
    height: 32px;
  }
  .fileBox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    .btnRow {
      width: 100%;
      padding-top: 30px;
      padding-bottom: 20px;
      display: flex;
      justify-content: flex-end;
      /deep/.el-button {
        font-size: 20px;
        font-weight: normal;
        border: none;
        width: 170px;
        height: 48px;
        background: #40a0f2;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    .tableBox {
      height: calc(100% - 20px);
      /deep/.zk-table {
        height: 100%;
        .zk-table__body-wrapper {
          height: calc(100% - 65px) !important;
          overflow-y: auto;
        }
      }
    }
  }
  // 修改表格样式
  /deep/.zk-table {
    font-size: 16px;
  }
  /deep/.zk-table__body-row {
    height: 60px;
  }
  /deep/.zk-table__body-row:not(:first-of-type) {
    // border-top: none;
  }
  /deep/.zk-table__header-row {
    background-color: #40a0f2;
    line-height: 50px;
    font-size: 20px;
    color: #fff;
    .zk-table__header-cell {
      font-weight: normal;
    }
  }
  /deep/.zk-table--firstProp-header-inner {
    padding-left: 15px;
  }
}
.addLast {
  cursor: pointer;
  margin-left: 10px;
}
.addLast:hover {
  color: #0099ff;
}
.overFlowInTable {
  display: block;
  width: 350px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
</style>